"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PickupMethods = exports.PickupCodes = exports.ShippingMethodServiceLevel = exports.ShippingDate = exports.ShippingMethodTypes = void 0;
var ShippingMethodTypes;
(function (ShippingMethodTypes) {
    ShippingMethodTypes["SDDP"] = "premiumdeliveryshippinggroup";
    ShippingMethodTypes["SDD"] = "dropoffshippinggroup";
    ShippingMethodTypes["STORE_PICKUP"] = "storepickupshippinggroup";
    ShippingMethodTypes["STORE_EXPRESS_PICKUP"] = "expressc2spickupshippinggroup";
    ShippingMethodTypes["EXPRESS_SHIPPING"] = "overnight";
    ShippingMethodTypes["STANDARD_SHIPPING"] = "priority";
    ShippingMethodTypes["STANDARD"] = "standard";
    ShippingMethodTypes["THIRD_PARTY_SHIPPING_STANDARD"] = "thirdpartyshippingstandard";
    ShippingMethodTypes["IHX"] = "ihxshippinggroup";
    ShippingMethodTypes["GROUND"] = "standard";
    ShippingMethodTypes["TWODAY"] = "expedited";
    ShippingMethodTypes["NEXTDAY"] = "overnight";
})(ShippingMethodTypes = exports.ShippingMethodTypes || (exports.ShippingMethodTypes = {}));
var ShippingDate;
(function (ShippingDate) {
    ShippingDate["TODAY"] = "Today";
    ShippingDate["TOMORROW"] = "Tomorrow";
    ShippingDate["HANDSOFF"] = "Later";
})(ShippingDate = exports.ShippingDate || (exports.ShippingDate = {}));
var ShippingMethodServiceLevel;
(function (ShippingMethodServiceLevel) {
    ShippingMethodServiceLevel["serviceLevelSDD"] = "hand_off";
    ShippingMethodServiceLevel["serviceLevelSDDP"] = "premium";
    ShippingMethodServiceLevel["serviceLevelIHX"] = "ihx";
})(ShippingMethodServiceLevel = exports.ShippingMethodServiceLevel || (exports.ShippingMethodServiceLevel = {}));
var PickupCodes;
(function (PickupCodes) {
    PickupCodes[PickupCodes["CURBSIDE"] = 231] = "CURBSIDE";
    PickupCodes[PickupCodes["INSTORE"] = 97] = "INSTORE";
    PickupCodes[PickupCodes["EXPERTPICKUP"] = 97] = "EXPERTPICKUP";
    PickupCodes[PickupCodes["GNG"] = 262] = "GNG";
})(PickupCodes = exports.PickupCodes || (exports.PickupCodes = {}));
var PickupMethods;
(function (PickupMethods) {
    PickupMethods["CURBSIDE"] = "curbside";
    PickupMethods["INSTORE"] = "instore";
    PickupMethods["EXPERTPICKUP"] = "expertPickup";
    /* Quick pickup is Grab N Go */
    PickupMethods["GNG"] = "quickPickup";
})(PickupMethods = exports.PickupMethods || (exports.PickupMethods = {}));
//# sourceMappingURL=DeliveryInfoWLSProps.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/components/panels/DeliveryInfoWLS/DeliveryInfoWLSProps.js
// module id = 815
// module chunks = 8